import { ApiAnalyticsValueMode } from "@/types/analytics/analytics.recruiting.types.ts";
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
  SelectItem,
} from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface ReportingValueModeSelectorProps {
  value: ApiAnalyticsValueMode | null | undefined;
  onChange: (mode: ApiAnalyticsValueMode) => void;
}

export function ReportingValueModeSelector({ value, onChange }: ReportingValueModeSelectorProps) {
  const { t } = useTranslation();

  const options: SelectItem[] = useMemo(
    () => [
      {
        id: ApiAnalyticsValueMode.total,
        title: t("common:total"),
        icon: "fa-light fa-circle-1",
      },
      {
        id: ApiAnalyticsValueMode.conversion,
        title: t("common:conversion"),
        icon: "fa-light fa-percent",
      },
      {
        id: ApiAnalyticsValueMode.funnel,
        title: t("common:funnel"),
        icon: "fa-light fa-filter",
      },
    ],
    [t]
  );

  const selectedOption = useMemo(() => {
    const mode = value || ApiAnalyticsValueMode.total;
    return options.find((x) => x.id === mode) || options[0];
  }, [value, options]);

  return (
    <DropdownMenu
      trigger={
        <Button
          variant={"secondary"}
          rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-down shrink-0"} />}
        >
          {selectedOption?.title}
        </Button>
      }
    >
      {options.map((option: SelectItem) => (
        <DropdownMenuItem
          key={`value-view-${option.id}`}
          title={option.title}
          leftIcon={option.icon ? <FontAwesomeIcon icon={option.icon} /> : undefined}
          isSelected={selectedOption?.id === option.id}
          onClick={() => {
            onChange(option.id as ApiAnalyticsValueMode);
          }}
        />
      ))}
    </DropdownMenu>
  );
}
